module.exports = __webpack_public_path__ + "img/stop_btn.ff889395.png";